import { z } from 'zod'

/**
 * Creates a Zod schema that accepts only plain objects
 * with z.custom<>() and treats the value as type T.
 *
 * @template T
 * @param {string} [message] Error text when validation fails.
 * @returns {z.ZodType<T>} Schema for a plain object.
 */
export function customObject<T>(
  message = 'Expected an object',
): z.ZodType<T> {
  return z.custom<T>().refine((value: unknown) =>
    z.object({}).passthrough().safeParse(value).success, { message })
}
